import { render, staticRenderFns } from "./PromoCodeField.vue?vue&type=template&id=8341cc90&"
import script from "./PromoCodeField.vue?vue&type=script&lang=js&"
export * from "./PromoCodeField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports